export default "__VITE_ASSET__D9z8j$nS__"